export default __webpack_public_path__ + "static/media/DFYN.c7d9f9d2.png";